import styled, { css } from 'styled-components';
import media from 'styled-media-query';
import React, { useEffect } from 'react';
import Img from 'next/image';
import transformTag from '../utils/transformTag';
import { IconsActionsWalksTours } from './detailBase/header/trailwalk';
import classNames from 'classnames';
import Link from 'next/link';
import dayjs from 'dayjs';

const CardWrapper = styled.div<{ small?: boolean }>`
  min-width: ${p => (p.small ? 132 : 192)}px;
  position: relative;
  ${p =>
    p.small
      ? css`
          width: 132px;
        `
      : undefined};
  background-color: white;

  border-radius: 8px 8px 0 0;

  ${media.greaterThan('large')`
    min-width: 250px;
  `}

  max-width: 272px;
`;

const ImageWrapper = styled.div`
  height: 300px;
  cursor: pointer;

  overflow: hidden;
  border-radius: 8px 8px 0 0;
  position: relative;

  & div img {
    object-fit: cover;
  }

  ${media.lessThan('medium')`
    height: 150px;
  `}
`;

const CardImage = styled(Img)`
  border-radius: 8px 8px 0 0;
  cursor: pointer;
` as typeof Img;

const Title = styled.h3`
  height: 32px;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  line-height: 16px;
  margin: 16px 12px;
  cursor: pointer;
  &.news {
    font-size: 18px;
  }
`;

const Description = styled.div`
  margin: 0 12px 12px;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  line-height: 16px;
  font-size: 12px;
  color: #5e5c5c;

  ${media.greaterThan('medium')`
    -webkit-line-clamp: 4;
  `}

  &.news {
    font-size: 14px;
    margin: 0 12px 42px !important;
  }
`;

const Date = styled.div`
  border-radius: 4px 0 0 4px;
  margin: 0 12px 12px;
  left: 0;
  bottom: 0;
  color: #ccc;
  font-weight: bold;
  font-size: 11px;
  z-index: 300;
  position: absolute;
`;

const Category = styled(Date)`
  text-transform: capitalize;
`;

const IconsContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  padding: 12px 0px;
`;

type Props = {
  title: string;
  image: string;
  description: string;
  date?: string;
  className?: string;
  category?: string;
  small?: boolean;
  style?: any;
  onClick?: () => void;
  isTrailWalk?: boolean;
  time?: number;
  distance?: number;
  imageStyle?: any;
  href?: any;
};

const Card = React.forwardRef<any, Props>(
  ({ href, imageStyle, time, distance, className, isTrailWalk, title, image, description, date, category, small, onClick, style }, ref) => {
    if (!image) return null;
    return (
      <CardWrapper ref={ref} small={small} onClick={onClick} style={style} className={classNames('shadow-lg', className)}>
        {category && <Category>{transformTag(category)}</Category>}
        <ImageWrapper style={imageStyle} className="hidden md:flex">
          <Link href={href} passHref>
            <a>
              <CardImage src={image} width={272} height={300} alt={title} />
            </a>
          </Link>
        </ImageWrapper>
        <ImageWrapper style={imageStyle} className="flex md:hidden">
          <CardImage src={image} width={isTrailWalk ? 272 : 192} height={150} alt={title} />
        </ImageWrapper>
        <Link href={href} passHref>
          <a>
            <Title>{title?.trim()}</Title>
          </a>
        </Link>
        <Description className={date ? 'news' : 'notnews'}>{description?.trim()}</Description>
        {date && <Date>{dayjs(date).format('ddd, MMM DD')}</Date>}
        {isTrailWalk && (
          <IconsContainer>
            <IconsActionsWalksTours item={{ time, distance }} noFaWalking style={{ width: '100%', height: '100%', alignItems: 'flex-end' }} />
          </IconsContainer>
        )}
      </CardWrapper>
    );
  },
);

export default Card;
